import { Button, TextField } from "@dash/form";
import { SectionHeader } from "@dash/page";
import { SelectDialog } from "@dash/select";
import { useToast } from "@dash/toast";
import { useProfiles } from "@megarax/features";
import Decimal from "decimal.js";
import { useState } from "react";

import { Region } from "@megaron/crm-contracts";
import { useClientManager } from "@megaron/react-clients";

import { LocationPicker, RegionOwnerAddress } from "./region/LocationPicker";
import { getAddressFromRegion } from "./region/RegionOwnerAddress";

type Props = {
  region?: Region;
  onSuccess: () => void;
};

export const AddRegion: React.FC<Props> = (props) => {
  const { allProfiles } = useProfiles();
  const toast = useToast();

  const saveRegion = useClientManager("crm").saveRegion().useMutation();

  const regionAddress: RegionOwnerAddress = props.region
    ? getAddressFromRegion(props.region)
    : {
        country: "",
        city: "",
        street: "",
        postalCode: "",
        latitude: null,
        longitude: null,
      };

  const [name, setName] = useState<string>(props.region?.name ?? "");
  const [ownerEmail, setOwnerEmail] = useState<string | null>(props.region?.ownerEmail || null);
  const [address, setAddress] = useState<RegionOwnerAddress>(regionAddress);

  const addRegionMutation = async () => {
    if (!name) {
      toast.error("Podaj nazwę regionu!");
      return;
    }

    if (
      (address.city || address.country || address.postalCode || address.street) &&
      (!address.latitude || !address.longitude)
    ) {
      toast.error("Wybierz adres w wyszukiwarce!");
      return;
    }

    saveRegion.mutate(
      {
        name,
        ownerEmail,
        addressCity: address.city,
        addressCountry: address.country,
        addressStreet: address.street,
        addressPostalCode: address.postalCode,
        homeLatitude: address.latitude ? new Decimal(address.latitude) : null,
        homeLongitude: address.longitude ? new Decimal(address.longitude) : null,
      },
      {
        onSuccess: (r) => {
          props.onSuccess();
        },
      },
    );
  };

  const options = allProfiles?.map((profile) => ({
    label: profile.firstName ? `${profile.firstName} ${profile.lastName}` : `${profile.email}`,
    value: profile.email,
  }));

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "1rem", maxHeight: "70vh", overflow: "auto" }}>
      <TextField
        css={{ input: { height: "46px" } }}
        label={"Region"}
        value={name}
        onChange={(value) => setName(value)}
        autoFocus
      />

      <SelectDialog
        label={"Handlowiec"}
        options={options ?? []}
        onSelect={(option) => setOwnerEmail(option?.value || null)}
        variant="single-select"
        initiallySelectedValues={ownerEmail ? [ownerEmail] : []}
      />

      <SectionHeader isHr>Adres</SectionHeader>
      <LocationPicker onAddressChange={(addr) => setAddress({ ...regionAddress, ...addr })} address={address} />
      <Button
        css={{ alignSelf: "flex-end", margin: "4px 0" }}
        onClick={addRegionMutation}
        isLoading={saveRegion.isLoading}
      >
        Zapisz
      </Button>
    </div>
  );
};
